import React, { useState } from 'react';
import { Fab, Box, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import AdminManualDialog from './AdminManualDialog';
import AdminUsersDialog from './AdminUsersDialog';

import UndoIcon from '@mui/icons-material/Undo';
import CloseIcon from '@mui/icons-material/Close';


const AdminButton = ({ 
  userIsAdmin,
  manualItems,
  onAddOrEditManual,
  onAddOrEditAdmin
}: any) => {
  const [openDialog, setOpenDialog] = useState<'manual' | 'users' | null>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleOpen = (dialogType: 'manual' | 'users') => {
    setOpenDialog(dialogType);
    // setIsMenuOpen(false);
  };

  const handleClose = () => {
    setOpenDialog(null);
  };

  return (
    <>
      <Box sx={{ position: 'fixed', bottom: 32, right: 32, zIndex: 1200 }}>
        <Fab
          color="primary"
          aria-label="admin actions"
          onClick={() => {
            setOpenDialog(null);
            if (openDialog !== 'manual') {
              setIsMenuOpen(!isMenuOpen)
            }
          }}
        >
          {isMenuOpen 
            ? openDialog === 'manual' 
              ? <UndoIcon /> 
              : <CloseIcon /> 
            : <AddIcon />
          }
        </Fab>

        {isMenuOpen && openDialog !== 'manual' && (
          <Box sx={{ 
            position: 'absolute', 
            bottom: '100%', 
            right: 0,
            mb: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 1
          }}>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => handleOpen('manual')}
              sx={{ whiteSpace: 'nowrap', justifyContent: 'flex-start' }}
            >
              Gestión de Manuales
            </Button>
            
            {userIsAdmin?.canManageAdmins && (
              <Button
                variant="contained"
                startIcon={<EditIcon />}
                onClick={() => handleOpen('users')}
                sx={{ whiteSpace: 'nowrap', justifyContent: 'flex-start' }}
              >
                Gestión de Administradores
              </Button>
            )}
          </Box>
        )}
        
        {isMenuOpen && openDialog === 'manual' && (
          <AdminManualDialog
            items={manualItems} 
            onAddOrEdit={onAddOrEditManual}
            userIsAdmin={userIsAdmin}
            onCloseMenu={() => setOpenDialog(null)}
          />
        )}
      </Box>


      {openDialog === 'users' && userIsAdmin?.canManageAdmins && (
        <AdminUsersDialog
          open={true}
          onClose={handleClose}
          onSubmit={onAddOrEditAdmin}
          userIsAdmin={userIsAdmin}
        />
      )}
    </>
  );
};

export default AdminButton;